/*
  STKR CUSTOM FILE: hero video loading (2026-09-25, theme-surgery/2026-09-25-hero-video-loading)

  Starts only the hero videos that are visible on this screen size, when they
  come near the viewport. Hidden desktop/mobile copies stay unloaded.
  Rendered by snippets/stkr-hero-video.liquid; safe to include more than once.
*/
(() => {
  if (window.stkrHeroVideo) return;
  window.stkrHeroVideo = true;

  const SELECTOR = 'video[data-stkr-hero-video]';

  // Zero client rects means the video or an ancestor is display: none.
  const isShown = (video) => video.getClientRects().length > 0;

  const play = (video) => {
    const playing = video.play();
    if (playing) playing.catch(() => {});
  };

  // Hand the chosen video to the browser's own autoplay, which also waits
  // correctly when the page opened in a background tab.
  const start = (video) => {
    video.muted = true;
    video.autoplay = true;
    video.dataset.stkrStarted = 'true';
    if (video.readyState === 0) {
      video.preload = 'auto';
      video.load();
    } else {
      play(video);
    }
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              start(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  const scan = () => {
    document.querySelectorAll(SELECTOR).forEach((video) => {
      if (isShown(video)) {
        if (video.dataset.stkrQueued) return;
        video.dataset.stkrQueued = 'true';
        if (observer) observer.observe(video);
        else start(video);
      } else if (video.dataset.stkrQueued) {
        delete video.dataset.stkrQueued;
        delete video.dataset.stkrStarted;
        if (observer) observer.unobserve(video);
        video.autoplay = false;
        video.pause();
      }
    });
  };

  // Backup for a tab brought to the front after the browser declined to play.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll(`${SELECTOR}[data-stkr-started]`).forEach((video) => {
      if (video.paused && isShown(video)) play(video);
    });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scan, 200);
  });
  document.addEventListener('shopify:section:load', scan);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
